export default {
  computed: {
    deleteProduct() {
      return this.$store.getters.MOBILE_CART_DELETE_MENU;
    },
    item() {
      return this.$store.getters.MOBILE_CART_MENU;
    },
  },
  methods: {
    deleteItem() {
      this.remove(this.item.index, this.item.parentIndex);
      this.$store.dispatch('CLOSE_ALL_MOBILE_MENU');
    }
  },
};
